// extracted by mini-css-extract-plugin
module.exports = {"root":"Announcement-root-1WbIM","text":"Announcement-text-22JJO"};